import React from "react";
import { ArrowRight, ArrowUpRight, Check, Sparkles } from "lucide-react";
import { PageShell } from "../components/Layout";
import { RoomCard, InfoCard, pics } from "../components/Cards";
import "./Services.css";
import { Link } from "react-router-dom";

const packages = [
  {
    name: "Premium Stay",
    detail: "Thoughtful extras for a more indulgent escape.",
    image: pics[0],
  },
  {
    name: "Best Vacation",
    detail: "Flexible, considered stays for memories that last.",
    image: pics[1],
  },
  {
    name: "Basic Stay",
    detail: "The beautiful essentials, with no compromise.",
    image: pics[3],
  },
];

export default function Services() {
  return (
    <PageShell>
      <main className="services container">
        <section className="services__hero">
          <div className="services__hero-heading">
            <p className="eyebrow">The Bryan Residence experience</p>
            <h1>
              expertise
              <br />
              <em>in every stay.</em>
            </h1>
            <p>
              From apartment availability to special requests, our team shapes
              every part of your stay around comfort, intelligent living and
              ease.
            </p>
          </div>

          <div className="services__composition">
            <div className="services__count">
              <b>179+</b>
              <span>
                unique spaces
                <br />
                curated with care
              </span>
            </div>
            <div
              className="services__main-image"
              style={{ backgroundImage: `url(${pics[5]})` }}
            >
              <span className="services__image-label">
                The Bryan Residence · Lekki
              </span>
            </div>
            <div
              className="services__small-image"
              style={{ backgroundImage: `url(${pics[1]})` }}
            />
            <div className="services__seal">
              <Sparkles size={18} />
              <span>
                Designed for
                <br />
                belonging
              </span>
            </div>
            <article className="services__floating-note">
              <span>01 — Bryan Residence standard</span>
              <p>
                Five automated three-bedroom apartments for family vacations,
                business trips, romantic getaways, extended stays and
                celebrations.
              </p>
              <ArrowUpRight size={16} />
            </article>
            <button
              className="services__play"
              aria-label="Explore our approach"
            >
              ↗
            </button>
          </div>
        </section>

        <section className="services__packages">
          <div className="services__packages-head">
            <div>
              <p className="eyebrow">Curated for your stay</p>
              <h2>
                Find your
                <br />
                perfect pace.
              </h2>
            </div>
            <p>
              Explore flexible stay options and exceptional service, whether you
              are visiting Lagos for business, rest or celebration.
            </p>
          </div>
          <div className="services__package-grid">
            {packages.map((item, index) => (
              <article
                className="services__package"
                key={item.name}
                style={{ backgroundImage: `url(${item.image})` }}
              >
                <span>0{index + 1}</span>
                <div>
                  <h3>
                    {item.name}
                    <br />
                    Packages
                  </h3>
                  <p>{item.detail}</p>
                  <Link to="/accommodation">
                  <button>
                    Explore package <ArrowRight size={15} />
                  </button>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="services__manifesto">
          <span>
            <Sparkles size={13} /> A 5-star way to stay
          </span>
          <h2>
            Committed to excellence,
            <br />
            creating comfort that
            <br />
            <em>lingers beautifully.</em>
          </h2>
          <p> Bryan Residence </p>
        </section>

        <section className="services__value">
          <div className="services__value-copy">
            <div className="services__value-numbers">
              <span>
                <b>17+</b> years of refined stays
              </span>
              <span>
                <b>2M</b> peaceful nights hosted
              </span>
            </div>
            <h2>
              Designed for calm,
              <br />
              made to feel like <em>home.</em>
            </h2>
            <p>
              Enjoy private cinema options, Story Apartment’s private jacuzzi
              and terrace, Disco Flame’s private bar, plus pool, gym,
              restaurant, Wi-Fi, housekeeping and 24-hour electricity.
            </p>
            <a href="#packages">
              Explore our promise <ArrowUpRight size={15} />
            </a>
          </div>
          <div
            className="services__value-image"
            style={{ backgroundImage: `url(${pics[0]})` }}
          >
            <span>
              Thoughtfully prepared
              <br />
              for your arrival
            </span>
          </div>
          <div className="services__value-list">
            {[
              "Free cancellation",
              "Private cinema, jacuzzi & bar",
              "Easy verification",
            ].map((feature, i) => (
              <div key={feature}>
                <span>0{i + 1}</span>
                <Check size={15} />
                <b>{feature}</b>
                <small>Every detail, made simple.</small>
              </div>
            ))}
          </div>
        </section>

        <section className="services__spot" id="packages">
          <div className="services__spot-head">
            <p className="eyebrow">Discover The Bryan Residence</p>
            <h2>our apartments</h2>
            <a href="/accommodation">
              Book your stay <ArrowUpRight size={16} />
            </a>
          </div>
          <div className="services__spot-grid">
            {[0, 1, 2].map((i) => (
              <RoomCard
                i={i}
                key={i}
                name={
                  [
                    "Study Apartment",
                    "Story Apartment",
                    "Silver Screen Apartment",
                  ][i]
                }
              />
            ))}
          </div>
        </section>
      </main>
    </PageShell>
  );
}
